import { resolveComponent as _resolveComponent, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, withModifiers as _withModifiers, withKeys as _withKeys, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, resolveDirective as _resolveDirective, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = {
  class: "row no-wrap full-width",
  style: {"gap":"4px"}
}
const _hoisted_3 = { class: "row no-wrap" }
const _hoisted_4 = { class: "row full-width" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { key: 1 }
const _hoisted_7 = {
  class: "row justify-left full-width q-py-xs no-wrap",
  style: {"margin-left":"-5px !important"}
}
const _hoisted_8 = {
  class: "text-h8 q-ml-sm q-mb-none",
  style: {"margin-top":"7px","font-weight":"500"}
}
const _hoisted_9 = { key: 3 }
const _hoisted_10 = { class: "row justify-center no-wrap full-width" }
const _hoisted_11 = {
  class: "q-mr-xs",
  style: {"overflow-x":"hidden","max-width":"80% !important"}
}
const _hoisted_12 = { class: "row justify-center q-ma-xs" }
const _hoisted_13 = { key: 0 }
const _hoisted_14 = { class: "text-h8 text-bold q-mt-md" }
const _hoisted_15 = {
  key: 0,
  class: "text-h8 text-bold q-mt-md"
}
const _hoisted_16 = {
  key: 2,
  class: "text-h8 text-bold q-mt-md q-mb-none"
}
const _hoisted_17 = {
  key: 4,
  class: "q-my-xs"
}
const _hoisted_18 = {
  key: 5,
  class: "text-h8 text-bold q-mt-md"
}
const _hoisted_19 = { class: "row justify-between q-mx-sm q-py-none no-wrap minw-selector" }
const _hoisted_20 = {
  key: 8,
  class: "row",
  style: {"margin-left":"-5px"}
}
const _hoisted_21 = {
  class: "text-h8 q-ml-sm",
  style: {"font-weight":"500","margin-top":"7px"}
}
const _hoisted_22 = { key: 10 }
const _hoisted_23 = { class: "text-h8 text-bold q-mb-none" }
const _hoisted_24 = { class: "col text-right" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MostaSelect = _resolveComponent("MostaSelect")!
  const _component_q_tooltip = _resolveComponent("q-tooltip")!
  const _component_q_input = _resolveComponent("q-input")!
  const _component_enum_display_list = _resolveComponent("enum-display-list")!
  const _component_date_range_display_item = _resolveComponent("date-range-display-item")!
  const _component_q_item_section = _resolveComponent("q-item-section")!
  const _component_q_item = _resolveComponent("q-item")!
  const _component_q_select = _resolveComponent("q-select")!
  const _component_element_options_settings_panel = _resolveComponent("element-options-settings-panel")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_menu = _resolveComponent("q-menu")!
  const _component_q_space = _resolveComponent("q-space")!
  const _component_q_chip = _resolveComponent("q-chip")!
  const _component_formulas_list = _resolveComponent("formulas-list")!
  const _component_q_separator = _resolveComponent("q-separator")!
  const _component_recursive_selector = _resolveComponent("recursive-selector")!
  const _component_aux_selector = _resolveComponent("aux-selector")!
  const _component_selector_popup = _resolveComponent("selector-popup")!
  const _component_variable_display_list = _resolveComponent("variable-display-list")!
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_color = _resolveComponent("q-color")!
  const _component_q_popup_proxy = _resolveComponent("q-popup-proxy")!
  const _directive_close_popup = _resolveDirective("close-popup")!

  return (_ctx.theModel)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_MostaSelect, {
            modelValue: _ctx.widthModel,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.widthModel) = $event)),
            class: "q-mb-xs",
            style: {"flex":"1 1 0","min-width":"0"},
            options: _ctx.widthOptions
          }, null, 8, ["modelValue", "options"]),
          _withDirectives(_createVNode(_component_MostaSelect, {
            modelValue: _ctx.elementWidthModel,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.elementWidthModel) = $event)),
            class: "q-mb-xs",
            style: {"flex":"1 1 0","min-width":"0"},
            options: _ctx.elementWidthOptions
          }, null, 8, ["modelValue", "options"]), [
            [_vShow, _ctx.scaleLinear]
          ])
        ]),
        _createElementVNode("div", {
          class: _normalizeClass([{ 'text-red cursor-pointer': _ctx.stepIncorrect }, 'text-h8 text-bold q-mt-md'])
        }, [
          _createTextVNode(_toDisplayString(_ctx.$t('x_step')) + " ", 1),
          (_ctx.stepIncorrect)
            ? (_openBlock(), _createBlock(_component_q_tooltip, {
                key: 0,
                delay: 1000
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.stepIncorrect), 1)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ], 2),
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_q_input, {
            modelValue: _ctx.stepValueModel,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.stepValueModel) = $event)),
            modelModifiers: { number: true },
            debounce: "400",
            type: "number",
            dense: "",
            class: "thin-input q-mr-sm",
            outlined: "",
            onKeydown: _cache[3] || (_cache[3] = _withKeys(_withModifiers(() => {}, ["stop","prevent"]), ["enter"]))
          }, null, 8, ["modelValue"]),
          _createVNode(_component_enum_display_list, {
            elements: _ctx.linearStepToList,
            "enum-to-string": _ctx.LinearStepToStr,
            "allow-multiple": false,
            combobox: true,
            "element-type": 8,
            modelValue: _ctx.stepModel,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.stepModel) = $event))
          }, null, 8, ["elements", "enum-to-string", "modelValue"])
        ]),
        _createElementVNode("div", {
          class: _normalizeClass([{ 'text-red cursor-pointer': _ctx.datesIncorrect }, 'text-h8 text-bold q-mt-md'])
        }, [
          _createTextVNode(_toDisplayString(_ctx.$t('range')) + " ", 1),
          (_ctx.datesIncorrect)
            ? (_openBlock(), _createBlock(_component_q_tooltip, {
                key: 0,
                delay: 1000
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.datesIncorrect), 1)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ], 2),
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_date_range_display_item, {
            modelValue: _ctx.dateInnerModel,
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.dateInnerModel) = $event)),
            modelType: 2,
            "show-time": _ctx.genstore.selectedItem.DestType === 6 && _ctx.stepModel.includes(5)
          }, null, 8, ["modelValue", "show-time"])
        ]),
        ((_ctx.theModel as PersonLinearChartSettings)?.Descriptor === 12)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _createVNode(_component_q_select, {
                flat: "",
                modelValue: _ctx.factFlagsModelPerson,
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.factFlagsModelPerson) = $event)),
                "hide-bottom-space": "",
                multiple: "",
                "bottom-slots": false,
                dense: "",
                outlined: "",
                clearable: "",
                "input-debounce": "500",
                label: _ctx.factFlagsModelPerson ? _ctx.$t('contacts_count_in_set') : '',
                ref: "facts_status_select",
                "hide-dropdown-icon": false,
                options: _ctx.factFlagsOptionsPerson
              }, {
                "no-option": _withCtx(() => [
                  _createVNode(_component_q_item, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_q_item_section, { class: "text-grey" }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t('no_data_found')), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["modelValue", "label", "options"])
            ]))
          : _createCommentVNode("", true),
        ((_ctx.theModel as PersonLinearChartSettings)?.Descriptor === 9)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _createVNode(_component_q_select, {
                flat: "",
                modelValue: _ctx.factFlagsModelFile,
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.factFlagsModelFile) = $event)),
                "hide-bottom-space": "",
                multiple: "",
                "bottom-slots": false,
                dense: "",
                outlined: "",
                clearable: "",
                "input-debounce": "500",
                label: _ctx.factFlagsModelFile ? _ctx.$t('files_count_in_set') : '',
                ref: "facts_status_select",
                "hide-dropdown-icon": false,
                options: _ctx.factFlagsOptionsFile
              }, {
                "no-option": _withCtx(() => [
                  _createVNode(_component_q_item, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_q_item_section, { class: "text-grey" }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t('no_data_found')), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["modelValue", "label", "options"])
            ]))
          : _createCommentVNode("", true),
        (_ctx.hasAnalyticElementOptions)
          ? (_openBlock(), _createBlock(_component_element_options_settings_panel, {
              key: 2,
              modelValue: _ctx.theModel.Options,
              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.theModel.Options) = $event))
            }, null, 8, ["modelValue"]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_7, [
          _createVNode(_component_q_btn, {
            class: "q-my-none q-pa-none text-left text-md",
            flat: "",
            "no-caps": "",
            align: "left",
            size: "13px",
            color: "grey-8",
            icon: "add",
            onClick: _ctx.addNewGElement,
            "aria-label": _ctx.$t('add_curve')
          }, null, 8, ["onClick", "aria-label"]),
          _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.$t('curves')), 1)
        ]),
        (_ctx.curveModel)
          ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.curveModel, (curve, index) => {
                return (_openBlock(), _createBlock(_component_q_chip, {
                  removable: "",
                  square: "",
                  "icon-selected": "none",
                  "icon-remove": "delete",
                  key: curve.Id,
                  selected: _ctx.selectedId === curve.Id,
                  onClick: () => { _ctx.selectedId = curve.Id; _ctx.tempName = curve.Name; },
                  style: _normalizeStyle(`background-color: ${_ctx.curve_index === index ? '#F0F0F0' : '#FFFFFF'};`),
                  "text-color": "grey-9",
                  class: "cursor-pointer full-width no-icon-chip",
                  onRemove: ($event: any) => (_ctx.deleteGElement(index))
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_10, [
                      _createElementVNode("div", _hoisted_11, _toDisplayString(curve.Name), 1),
                      _createVNode(_component_q_btn, {
                        class: "q-my-none q-mx-xs q-pa-none",
                        flat: "",
                        dense: "",
                        color: "grey-7",
                        "aria-label": _ctx.$t('rename'),
                        icon: "edit",
                        size: "xs",
                        onClick: _cache[10] || (_cache[10] = _withModifiers(() => {}, ["stop","prevent"])),
                        onMousedown: _cache[11] || (_cache[11] = _withModifiers(() => {}, ["stop","prevent"])),
                        onMouseup: (e) => { _ctx.renameBtnClick(index) }
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_q_tooltip, { delay: 1000 }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.$t('rename')), 1)
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_q_menu, {
                            fit: "",
                            style: {"max-width":"400px"},
                            anchor: "bottom end",
                            self: "top middle",
                            ref_for: true,
                            ref: (el) => { _ctx.menus[index] = el }
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("div", _hoisted_12, [
                                _createVNode(_component_q_input, {
                                  autogrow: "",
                                  autofocus: "",
                                  color: "white",
                                  ref_for: true,
                                  ref: (el) => { _ctx.inputs[index] = el },
                                  debounce: "500",
                                  multiline: "",
                                  dense: "",
                                  outlined: "",
                                  "hide-bottom-space": "",
                                  modelValue: _ctx.tempName,
                                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.tempName) = $event)),
                                  "no-error-icon": "",
                                  placeholder: _ctx.$t('name'),
                                  rules: [(val) => !!val || _ctx.$t('input_name')],
                                  onKeydown: _withKeys(_withModifiers((val) => { _ctx.renameGElement(index); }, ["stop","prevent"]), ["enter"])
                                }, null, 8, ["modelValue", "placeholder", "rules", "onKeydown"]),
                                _createVNode(_component_q_item_section, null, {
                                  default: _withCtx(() => [
                                    _withDirectives((_openBlock(), _createBlock(_component_q_btn, {
                                      class: "q-my-none q-ml-xs q-pa-none unset-items-center",
                                      flat: "",
                                      dense: "",
                                      round: "",
                                      color: "grey-7",
                                      "bg-color": "transparent",
                                      onClick: ($event: any) => (_ctx.renameGElement(index)),
                                      "aria-label": _ctx.$t('apply_changes'),
                                      icon: "done",
                                      size: "sm"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_q_tooltip, { delay: 1000 }, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(_ctx.$t('apply_changes')), 1)
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 2
                                    }, 1032, ["onClick", "aria-label"])), [
                                      [_directive_close_popup]
                                    ])
                                  ]),
                                  _: 2
                                }, 1024)
                              ])
                            ]),
                            _: 2
                          }, 1536)
                        ]),
                        _: 2
                      }, 1032, ["aria-label", "onMouseup"]),
                      _createVNode(_component_q_space),
                      _createVNode(_component_q_btn, {
                        class: "q-my-none q-mx-xs q-pa-none",
                        flat: "",
                        dense: "",
                        color: "grey-7",
                        "aria-label": _ctx.$t('clone'),
                        icon: "content_copy",
                        size: "xs",
                        onClick: _withModifiers(($event: any) => (_ctx.cloneGElement(index)), ["stop","prevent"])
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_q_tooltip, { delay: 1000 }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.$t('clone')), 1)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 2
                      }, 1032, ["aria-label", "onClick"])
                    ])
                  ]),
                  _: 2
                }, 1032, ["selected", "onClick", "style", "onRemove"]))
              }), 128)),
              (_ctx.curveModel && _ctx.curveModel.length && _ctx.curve_index >= 0 && _ctx.curve_index < _ctx.curveModel.length)
                ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                    _createElementVNode("div", _hoisted_14, _toDisplayString(_ctx.$t('curve_settings')), 1),
                    (!_ctx.isEvaluateFormulas)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_15, _toDisplayString(_ctx.$t('evaluate_function')), 1))
                      : _createCommentVNode("", true),
                    (!_ctx.isEvaluateFormulas)
                      ? (_openBlock(), _createBlock(_component_enum_display_list, {
                          key: 1,
                          elements: _ctx.linearFunctionToList,
                          "enum-to-string": _ctx.LinearFunctionToStr,
                          "allow-multiple": false,
                          combobox: false,
                          "element-type": 8,
                          modelValue: _ctx.curveLinearModel,
                          "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.curveLinearModel) = $event))
                        }, null, 8, ["elements", "enum-to-string", "modelValue"]))
                      : _createCommentVNode("", true),
                    (_ctx.isLinearChart)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_16, _toDisplayString(_ctx.$t('func_label')), 1))
                      : _createCommentVNode("", true),
                    (_ctx.isLinearChart)
                      ? (_openBlock(), _createBlock(_component_enum_display_list, {
                          key: 3,
                          elements: _ctx.evaluateToList,
                          "enum-to-string": _ctx.EvaluateFunctionToStr,
                          "allow-multiple": false,
                          combobox: false,
                          "element-type": 8,
                          modelValue: _ctx.curveEvaluateModel,
                          "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.curveEvaluateModel) = $event))
                        }, null, 8, ["elements", "enum-to-string", "modelValue"]))
                      : _createCommentVNode("", true),
                    (_ctx.isLinearChart && _ctx.isEvaluateFormulas)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                          _createVNode(_component_formulas_list, {
                            "use-chart-mode": true,
                            "parameter-options": _ctx.graphstore.getCurrentFormulas,
                            "nested-key-name": "ChildFormulas",
                            "template-name": "Entity",
                            modelValue: (_ctx.curveModel[_ctx.curve_index] as ClientProjectLinearCurveTypes).Formulas,
                            "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => (((_ctx.curveModel[_ctx.curve_index] as ClientProjectLinearCurveTypes).Formulas) = $event)),
                            onChangePosition: _ctx.moveFormulaItem
                          }, null, 8, ["parameter-options", "modelValue", "onChangePosition"])
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.isEvaluateParameter)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_18, _toDisplayString(_ctx.$t('parameter')), 1))
                      : _createCommentVNode("", true),
                    (_ctx.isEvaluateParameter)
                      ? (_openBlock(), _createBlock(_component_q_btn, {
                          key: 6,
                          class: "q-my-none q-pa-none text-left text-md",
                          flat: "",
                          "no-caps": "",
                          align: "left",
                          size: "md",
                          color: "grey-8",
                          label: _ctx.parameterModelStr,
                          "aria-label": _ctx.$t('select_parameter')
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_q_tooltip, {
                              delay: 1000,
                              anchor: "top middle",
                              self: "center middle"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.$t('select_parameter')), 1)
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_q_menu, {
                              fit: "",
                              style: {"overflow":"hidden"},
                              onBeforeShow: _cache[20] || (_cache[20] = (e) => { _ctx.filter_string = '' })
                            }, {
                              default: _withCtx(() => [
                                _createElementVNode("div", _hoisted_19, [
                                  _createVNode(_component_q_input, {
                                    outlined: "",
                                    dense: "",
                                    ref: "panel_search_input",
                                    color: "white",
                                    class: "full-width thin-input q-my-auto",
                                    modelValue: _ctx.filter_string,
                                    "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.filter_string) = $event)),
                                    "hide-bottom-space": "",
                                    placeholder: _ctx.$t('search_label'),
                                    autofocus: "",
                                    debounce: "100",
                                    onKeydown: [
                                      _cache[16] || (_cache[16] = _withKeys(_withModifiers(($event: any) => (_ctx.$refs.rec_selector && (_ctx.$refs.rec_selector as any).trackArrowDown(1)), ["exact","prevent"]), ["down"])),
                                      _cache[17] || (_cache[17] = _withKeys(_withModifiers(($event: any) => (_ctx.$refs.rec_selector && (_ctx.$refs.rec_selector as any).trackArrowUp(1)), ["exact","prevent"]), ["up"]))
                                    ],
                                    onKeyup: _cache[18] || (_cache[18] = _withKeys(($event: any) => (_ctx.$refs.rec_selector && (_ctx.$refs.rec_selector as any).selectCurrent()), ["enter"]))
                                  }, null, 8, ["modelValue", "placeholder"]),
                                  _withDirectives((_openBlock(), _createBlock(_component_q_btn, {
                                    class: "q-my-sm q-px-none q-mr-none q-ml-lg",
                                    flat: "",
                                    dense: "",
                                    "aria-label": _ctx.$t('close_selector'),
                                    icon: "close",
                                    size: "md"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_q_tooltip, { delay: 1000 }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(_ctx.$t('close_menu')), 1)
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  }, 8, ["aria-label"])), [
                                    [_directive_close_popup]
                                  ])
                                ]),
                                _createVNode(_component_q_separator, { class: "q-my-none q-py-none" }),
                                _createVNode(_component_recursive_selector, {
                                  style: {"max-height":"50vh","overflow":"auto"},
                                  elements: (_ctx.theModel as ClientProjectLinearTypes).Parameters,
                                  "take-ids-only": true,
                                  "allow-multiple": false,
                                  "element-type": 1,
                                  modelValue: _ctx.curveParameterModel,
                                  "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.curveParameterModel) = $event)),
                                  "return-type": "chain",
                                  "nested-key-name": _ctx.NestedKeyName,
                                  "parameter-type-name": "Type",
                                  "filter-out-list": [3,6,7],
                                  "filter-string": _ctx.filter_string,
                                  ref: "rec_selector"
                                }, null, 8, ["elements", "modelValue", "nested-key-name", "filter-string"])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }, 8, ["label", "aria-label"]))
                      : _createCommentVNode("", true),
                    (!_ctx.isEvaluateFormulas)
                      ? (_openBlock(), _createBlock(_component_MostaSelect, {
                          key: 7,
                          modelValue: _ctx.sectorAnalyzedModel,
                          "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.sectorAnalyzedModel) = $event)),
                          class: "q-mb-xs",
                          "option-label": "Name",
                          label: _ctx.$t('analyzed_element'),
                          options: _ctx.genstore.analyzedListForChart
                        }, null, 8, ["modelValue", "label", "options"]))
                      : _createCommentVNode("", true),
                    ([9, 12, 15].includes((_ctx.theModel as any)?.Descriptor))
                      ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                          _createVNode(_component_q_btn, {
                            ref: "workerMenuTrigger",
                            class: "q-my-none q-pa-none text-left text-md",
                            flat: "",
                            "no-caps": "",
                            align: "left",
                            size: "13px",
                            color: "grey-8",
                            icon: "add",
                            "aria-label": _ctx.$t('choose_user'),
                            onClick: _cache[22] || (_cache[22] = ($event: any) => (_ctx.workerMenuVisible = !_ctx.workerMenuVisible))
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_q_tooltip, {
                                delay: 1000,
                                anchor: "top middle",
                                self: "center middle"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.$t('choose_user')), 1)
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }, 8, ["aria-label"]),
                          _createVNode(_component_selector_popup, {
                            visible: _ctx.workerMenuVisible,
                            "onUpdate:visible": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.workerMenuVisible) = $event)),
                            "trigger-el": _ctx.$refs.workerMenuTrigger,
                            "wide-layout": ""
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_aux_selector, {
                                "model-type": 6,
                                "input-index": 0,
                                "limit-height-to-container": true,
                                "allow-multiple": true,
                                modelValue: _ctx.curveWorkersModel,
                                "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.curveWorkersModel) = $event)),
                                onSelectorClosed: _cache[24] || (_cache[24] = ($event: any) => (_ctx.workerMenuVisible = false))
                              }, null, 8, ["modelValue"])
                            ]),
                            _: 1
                          }, 8, ["visible", "trigger-el"]),
                          _createElementVNode("div", _hoisted_21, _toDisplayString(_ctx.$t('users')), 1)
                        ]))
                      : _createCommentVNode("", true),
                    ([9, 12, 15].includes((_ctx.theModel as any)?.Descriptor))
                      ? (_openBlock(), _createBlock(_component_variable_display_list, {
                          key: 9,
                          class: "q-mb-sm",
                          modelValue: _ctx.curveWorkersModel,
                          "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.curveWorkersModel) = $event)),
                          onItemDeleted: _ctx.deleteWorker,
                          modelType: 1,
                          modelCategory: 0
                        }, null, 8, ["modelValue", "onItemDeleted"]))
                      : _createCommentVNode("", true),
                    ((_ctx.theModel as JobLinearChartSettings)?.Descriptor === 6)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                          _createVNode(_component_q_select, {
                            flat: "",
                            modelValue: _ctx.jobStatusModel,
                            "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((_ctx.jobStatusModel) = $event)),
                            class: "no-select-border q-mb-xs",
                            "hide-bottom-space": "",
                            multiple: "",
                            "bottom-slots": false,
                            dense: "",
                            outlined: "",
                            clearable: "",
                            "input-debounce": "500",
                            label: !_ctx.jobStatusModel || !_ctx.jobStatusModel.length ? _ctx.$t('statuses') : '',
                            ref: "job_status_select",
                            "hide-dropdown-icon": false,
                            options: _ctx.jobStatusOptions
                          }, {
                            "no-option": _withCtx(() => [
                              _createVNode(_component_q_item, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_q_item_section, { class: "text-grey" }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(_ctx.$t('no_data_found')), 1)
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }, 8, ["modelValue", "label", "options"])
                        ]))
                      : _createCommentVNode("", true),
                    ((_ctx.curveModel as ClientProjectLinearCurveTypes)?.EvaluateFunction === 0 && (_ctx.theModel as ClientProjectLinearTypes)?.Descriptor === 3)
                      ? (_openBlock(), _createBlock(_component_q_select, {
                          key: 11,
                          flat: "",
                          modelValue: _ctx.curveStageModel,
                          "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => ((_ctx.curveStageModel) = $event)),
                          "use-input": "",
                          "fill-input": "",
                          multiple: "",
                          outlined: "",
                          "use-chips": "",
                          "input-debounce": "500",
                          label: _ctx.$t('stages'),
                          options: (_ctx.theModel as ProjectLinearChartSettings).Stages?.map(el => { return { value: el.Id, label: el.Name }})
                        }, {
                          "no-option": _withCtx(() => [
                            _createVNode(_component_q_item, null, {
                              default: _withCtx(() => [
                                _createVNode(_component_q_item_section, { class: "text-grey" }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.$t('no_data_found')), 1)
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }, 8, ["modelValue", "label", "options"]))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_23, _toDisplayString(_ctx.$t('color')), 1),
                    _createElementVNode("div", {
                      class: "row justify-right q-pa-xs text-overline cursor-pointer",
                      outlined: "",
                      style: _normalizeStyle(`background-color: ${_ctx.curveColorModel}; width: 100%; border-radius: 4px; color: white;`)
                    }, [
                      _createTextVNode(_toDisplayString(_ctx.curveColorModel) + " ", 1),
                      _createElementVNode("div", _hoisted_24, [
                        _createVNode(_component_q_icon, {
                          name: "colorize",
                          size: "sm"
                        }),
                        _createVNode(_component_q_popup_proxy, {
                          cover: "",
                          "transition-show": "scale",
                          "transition-hide": "scale"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_q_color, {
                              modelValue: _ctx.curveColorModel,
                              "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => ((_ctx.curveColorModel) = $event))
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        })
                      ])
                    ], 4)
                  ]))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true)
      ]))
    : _createCommentVNode("", true)
}